import { render, staticRenderFns } from "./ManagerDashboard3.vue?vue&type=template&id=593b525a&scoped=true&"
import script from "./ManagerDashboard3.vue?vue&type=script&lang=js&"
export * from "./ManagerDashboard3.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDashboard3.vue?vue&type=style&index=0&id=593b525a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593b525a",
  null
  
)

export default component.exports